<script setup lang="ts">
import FormFieldCell from './FormFieldCell.vue'
import type { WidgetAttributes } from '../utils/claim-editor'
import { useClaimFormContext, type FieldValue } from '../composables/fields'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  name: string
  attributes: WidgetAttributes
  dataType?: 'string' | 'number'
}>()

const { state } = useClaimFormContext()

const onUpdate = (value: FieldValue) => {
  if (typeof value === 'string' && value.trim() === '') {
    state[props.name] = undefined
    return
  }

  state[props.name] =
    props.dataType === 'number' && !Number.isNaN(Number(value))
      ? Number(value)
      : value
}
</script>

<template>
  <FormFieldCell :name="props.name">
    <UInput
      v-bind="attributes"
      :name="props.name"
      class="w-full"
      :model-value="state[props.name]"
      :ui="{ base: 'p-2 rounded-none' }"
      size="xs"
      variant="none"
      @update:model-value="onUpdate"
    />
  </FormFieldCell>
</template>
